import { Wrapper as CollapseWrapper } from 'Components/flowChart/components/Collapse/index.style';
import styled from 'styled-components';

export const Wrapper = styled.div`
	border-radius: 10px;
	width: 260px;
	box-shadow: 0px 3px 20px 0px #002e5933;
	background-color: #fff;
	z-index: 201;
`;

export const WrapperContent = styled.div`
	max-height: 350px;
	overflow: auto;
	border-top: 1px solid #e5e5e5;

	${CollapseWrapper} {
		:first-child {
			border-top: none;
		}
	}
`;
